// C:\Users\VRS IT\Music\CleanSlate\cleanslate\src\Context\UserContext.jsx
import { createContext, useCallback, useContext, useState, useEffect, useRef } from "react";
import Cookies from "js-cookie";
import { GetUserData } from "../Services/UserDataService";

const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
    const [userImgUrl, setUserImgUrl] = useState("");
    const [fullName, setFullName] = useState("");
    const [userEmail, setuserEmail] = useState("");
    const hasFetchedRef = useRef(false);

    const refreshUser = useCallback(() => {
        if (hasFetchedRef.current) return;

        const token = Cookies.get("token");
        if (!token) {
            hasFetchedRef.current = false;
            setUserImgUrl("");
            setFullName("");
            return;
        }
        hasFetchedRef.current = true;
        const cachedName = Cookies.get("FullName") || "";
        const cachedEmail = Cookies.get("Email") || "";
        if (cachedName) setFullName(cachedName);
        if (cachedEmail) setuserEmail(cachedEmail);

        GetUserData(token)
            .then((res) => {
                setUserImgUrl(res?.userDetails?.userImgUrl || "");
                if (res?.userDetails?.fullName) setFullName(res.userDetails.fullName)
                if (res?.userDetails?.email) setuserEmail(res.userDetails.email);
            })
            .catch(() => { hasFetchedRef.current = false; });
    }, []);

    useEffect(() => {
        refreshUser();

        const handleAuthChange = () => {
            hasFetchedRef.current = false;
            refreshUser();
        };

        window.addEventListener("auth-change", handleAuthChange);
        return () => window.removeEventListener("auth-change", handleAuthChange);
    }, [refreshUser]);

    return (
        <UserContext.Provider value={{ userImgUrl, setUserImgUrl, fullName, setFullName, refreshUser, userEmail }}>
            {children}
        </UserContext.Provider>
    );
};

export const useUser = () => useContext(UserContext);
